if (!window.customElements.get("component-articles-slider")) {

  class RelatedArticlesSlider extends HTMLElement {

    constructor() {
      super();

      this.selectors = {
        swiper: ".related-articles__wrapper",
        prevEl: ".custom-prev-button",
        nextEl: ".custom-next-button"
      }

      this.slider = this.querySelector(this.selectors.swiper);
      this.buttonPrev = this.querySelector(this.selectors.prevEl);
      this.buttonNext = this.querySelector(this.selectors.nextEl);
      this.initSlider();
    }

    initSlider() {
      const swiperParams = {
        slidesPerView: 1.3095,
        spaceBetween: 10,
        slidesOffsetBefore: 10,
        slidesOffsetAfter: 10,
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
            slidesOffsetBefore: 10,
            slidesOffsetAfter: 10,
          },
          990: {
            slidesPerView: 3,
            spaceBetween: 20,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
          },
        },
        navigation: {
          nextEl: this.buttonNext,
          prevEl: this.buttonPrev
        },
        on: {
          init() {
          }
        },
      };

      Object.assign(this.slider, swiperParams);

      this.slider.initialize();

    }
  }

  customElements.define('component-articles-slider', RelatedArticlesSlider);
}
